module.exports = __webpack_public_path__ + "static/img/bcdf.de21d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bcdf.png
// module id = 5EPp
// module chunks = 1